/*getData*/
;(function ($,win,doc,y) {
    let str="";
    init();
    function init(){
        const id=$("body").attr('id'),
              lang=$("html").attr('lang');
        if(id!==undefined){
          eval(id+"(lang)");
        }
    }
    function flagHome(lang){
        $("a").off("click.animsition");
        //广告图
        y.ajax.getMultiRecord({categoryId:69}, (res)=>{
            res.data.forEach((v)=>{
                  str+=['<div class="swiper-slide">',
                      '<div class="hawa-banner home-page text-center buttons-modern">',
                      '<img src="'+router+v.img_url+'" alt="" class="img-simple s-img-switch">',
                      '<div class="content col-md-12">',
                      '<div class="buttons-buttom">',
                      '<a href="img/17AW Decent trend book.pdf" target="_blank" class="black">17SS Decent Trend Book</a>',
                      '<a href="img/17AW Decent trend book.pdf" target="_blank" class="white">17AW Decent Trend Book</a>',
                      '</div>',
                      '</div>',
                      '</div>',
                      '</div>'].join("");
            });
            $("#swiper-1").append(str);
            y.initSwiper();
            str="";
        });
        //解决方案
        y.ajax.getMultiRecord({categoryId:25}, (res)=> {
            res.data.forEach((v)=>{
                  if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                      $("#title-1").html(unescape(v.zhaiyao));
                      $("#title-2").html(v.title);
                      $("#content-1").html(unescape(v.content));
                  }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                      $("#title-1").html(unescape(v.zhaiyao));
                      $("#title-2").html(v.title);
                      $("#content-1").html(unescape(v.content));
                  }
            });
        });
        //优势
        y.ajax.getMultiRecord({categoryId:70}, (res)=> {
            let img=[],
                content=[],
                title=[];
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    img.push(router+v.img_url);
                    content.push(unescape(v.content));
                    title.push(v.title);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    img.push(router+v.img_url);
                    content.push(unescape(v.content));
                    title.push(v.title);
                }
            });

            img.forEach((v,i)=>{
                $("#all-1").find(".icon").children('img')[i].src=v;
            });
            content.forEach((v,i)=>{
                $("#all-1").find(".content")[i].innerHTML=v;
            });
            title.forEach((v,i)=>{
                $("#all-1").find(".title")[i].innerHTML=v;
            });
        });
        //业务服务
        const promise= new Promise((resolve,reject)=>{
            y.ajax.getMultiRecord({categoryId:71}, (res)=> {
                let arr=[],
                    content=[],
                    title=[];
                res.data.forEach((v)=>{
                    arr.push(router+v.img_url);
                    content.push(unescape(v.content));
                    title.push(v.title);
                });
                y.imgLoaded(arr,(img)=>{
                    arr.forEach((v,i)=>{
                        if(img[i].width/img[i].height>1){
                            str+=['<div class="portfolio-item pi col-sm-6 col-md-3  col-no-padd">',
                                '<img src="'+v+'" class="bg-responsive-img item-img" alt="Untitled-1">',
                                '<div class="layer">',
                                '<a href="business.html" class="animsition-link " data-effect="zoomIn">',
                                '<span class="icon-item icon-attachment"></span>',
                                '<h4 class="item-title">'+title[i]+'<br>'+content[i]+'</h4>',
                                '</a>',
                                '</div>',
                                '</div>'].join("");
                        }else{
                            str+=['<div class="portfolio-item pi col-sm-6 col-md-3  col-no-padd">',
                                '<img src="'+v+'" class="bg-responsive-img item-img" alt="Untitled-14">',
                                '<div class="layer">',
                                '<a href="ios.html" class="animsition-link " data-effect="zoomIn">',
                                '<span class="icon-item icon-attachment"></span>',
                                '<h4 class="item-title">'+title[i]+'<br>'+content[i]+'</h4>',
                                '</a>',
                                '</div>',
                                '</div>'].join("");
                        }
                    });
                    $('#masonry').append(str);
                    setTimeout(()=>{
                        y.izotope_portfolio();
                    },200);
                    str="";
                    resolve();
                })
            });
        });
        //设计师
        promise.then(()=>{
           y.ajax.getMultiRecord({categoryId:98}, (res)=> {
               res.data.forEach((v)=>{
                   if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                       str+='<div class="swiper-slide" >'+
                           '<div class="hawa-team modern  modern text-center">'+
                           '<div class="wrapper">'+
                           '<a href="design.html?'+v.id+'" data-fancybox="'+v.id+'">'+
                           '<img src="'+router+v.img_url+'" alt="">'+
                           '<div class="hover  ">'+
                           '<div class="title">work experience</div>'+
                           '<div class="text ellipsis">'+unescape(v.content)+'</div>'+
                           '</div>'+
                           '</a>'+
                           '</div>'+
                           '<div class="name">'+v.title+'</div>'+
                           '<div class="position">creative head</div>'+
                           '</div>'+
                           '</div>';
                   }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                       str+='<div class="swiper-slide" >'+
                           '<div class="hawa-team modern  modern text-center">'+
                           '<div class="wrapper">'+
                           '<a href="design.html?'+v.id+'" data-fancybox="'+v.id+'">'+
                           '<img src="'+router+v.img_url+'" alt="">'+
                           '<div class="hover  ">'+
                           '<div class="title">work experience</div>'+
                           '<div class="text ellipsis">'+unescape(v.content)+'</div>'+
                           '</div>'+
                           '</a>'+
                           '</div>'+
                           '<div class="name">'+v.title+'</div>'+
                           '<div class="position">creative head</div>'+
                           '</div>'+
                           '</div>';
                   }
               });
               setTimeout(()=>{
                   $("#swiper-2").append(str);
                   str="";
                   y.initSwiper();
               },200)
           });
       });
        //视频
        y.ajax.getMultiRecordVideo({categoryId:72},(res)=>{
              const video= $("#video");
              res.data.forEach((v)=>{
                  if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                      video.find(".video-title").html(v.title);
                      video.find(".video-text").html(unescape(v.content));
                      video.find("img").attr("src",router+v.img_url);
                      video.find(".video-btn").attr("href",v.video_src);
                  }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                        video.find(".video-title").html(v.title);
                        video.find(".video-text").html(unescape(v.content));
                        video.find("img").attr("src",router+v.img_url);
                        video.find(".video-btn").attr("href",v.video_src);
                  }
              })
       });
        //公司愿景
        y.ajax.getMultiRecord({categoryId:73}, (res)=> {
            const txt=$("#txt");
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    $(".bg-four").css({
                        backgroundImage: 'url('+router+v.img_url+')',
                    });
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    $(".bg-four").css({
                         backgroundImage: 'url('+router+v.img_url+')',
                    });
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                }
            });
        });
        //客户logo
        y.ajax.getMultiRecord({categoryId:74}, (res)=> {
            res.data.forEach((v)=>{
                str+=['<div class="clients-item col-md-2 col-sm-4 col-xs-12">',
                    '<img class="service-icon" src="'+router+v.img_url+'" alt="">',
                    '</div>'].join("");
            });
            $("#logo").append(str);
            str="";
        });

    }
    function flagAdvantage(lang){
        function content(res,txt) {
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find(".video-title").html(v.title);
                    txt.find(".video-text").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    txt.find(".video-title").html(v.title);
                    txt.find(".video-text").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }
            })
        }
        function swiper(res,el){
            res.data.forEach((v)=>{
                str+=['<div class="swiper-slide">',
                    '<div class="hawa-banner  text-center buttons-modern">',
                    '<img src="'+router+v.img_url+'" alt="" class="img-simple">',
                    '<div class="content col-md-12">',
                    '<div class="titles"></div>',
                    '<div class="buttons-buttom"></div>',
                    '</div>',
                    '</div>',
                    '</div>'].join("");
            });
            $(el).append(str);
            str="";
        }
        //四大核心优势
        y.ajax.getMultiRecord({categoryId:103},(res)=>{
            const txt=$("#content-1");
            content(res,txt);
        });
        //设计能力
        y.ajax.getMultiRecord({categoryId:102},(res)=>{
            const txt=$("#content-2");
            content(res,txt);
        });
        //纱线研发
        y.ajax.getMultiRecord({categoryId:101},(res)=>{
            const txt=$("#content-3");
            content(res,txt);
        });
        //生产模式
        y.ajax.getMultiRecord({categoryId:100},(res)=>{
            const txt=$("#content-4");
            content(res,txt);
        });
        //原料优势
        y.ajax.getMultiRecord({categoryId:99},(res)=>{
            const txt=$("#content-5");
            content(res,txt);
        });
        //设计研发图集 纱线研发图集 生产原料研发图集
        const promise= new Promise((resolve,reject)=>{
            y.ajax.getMultiRecord({categoryId:76},(res)=>{
                swiper(res,"#swiper-1");
                resolve();
            });
        });
        promise.then(()=>{
            return new Promise((resolve,reject)=>{
                y.ajax.getMultiRecord({categoryId:77},(res)=>{
                    swiper(res,"#swiper-2");
                    resolve()
                });
            })
        }).then(()=>{
            return new Promise((resolve,reject)=>{
                y.ajax.getMultiRecord({categoryId:78},(res)=>{
                    swiper(res,"#swiper-3");
                    resolve()
                });
            })
        }).then(()=>{
            Yfd.initSwiper();
        })

    }
    function flagBusiness(lang){
         //签约设计师服务
        y.ajax.getMultiRecord({categoryId:80}, (res)=> {
            const txt=$("#content-1");
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find(".video-title").html(v.title);
                    txt.find(".video-text").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    txt.find(".video-title").html(v.title);
                    txt.find(".video-text").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }
            });
        });
        const promise=new Promise((resolve,reject)=>{
            //设计师
            y.ajax.getMultiRecord({categoryId:98}, (res)=> {
                res.data.forEach((v)=>{
                    if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                        str+='<div class="swiper-slide" >'+
                            '<div class="hawa-team modern  modern text-center">'+
                            '<div class="wrapper">'+
                            '<a href="design.html?'+v.id+'" data-fancybox="'+v.id+'">'+
                            '<img src="'+router+v.img_url+'" alt="">'+
                            '<div class="hover  ">'+
                            '<div class="title">work experience</div>'+
                            '<div class="text ellipsis">'+unescape(v.content)+'</div>'+
                            '</div>'+
                            '</a>'+
                            '</div>'+
                            '<div class="name">'+v.title+'</div>'+
                            '<div class="position">creative head</div>'+
                            '</div>'+
                            '</div>';
                    }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                        str+='<div class="swiper-slide" >'+
                            '<div class="hawa-team modern  modern text-center">'+
                            '<div class="wrapper">'+
                            '<a href="design.html?'+v.id+'" data-fancybox="'+v.id+'">'+
                            '<img src="'+router+v.img_url+'" alt="">'+
                            '<div class="hover  ">'+
                            '<div class="title">work experience</div>'+
                            '<div class="text ellipsis">'+unescape(v.content)+'</div>'+
                            '</div>'+
                            '</a>'+
                            '</div>'+
                            '<div class="name">'+v.title+'</div>'+
                            '<div class="position">creative head</div>'+
                            '</div>'+
                            '</div>';
                    }
                });
                    $("#swiper-1").append(str);
                    str="";
                    resolve();
            });
        });
        promise.then(()=>{
            //BBS
            y.ajax.getMultiRecord({categoryId:97}, (res)=> {
                res.data.forEach((v)=>{
                    str+=['<div class="swiper-slide">',
                        '<div class="hawa-banner  text-center buttons-modern">',
                        '<img src="'+router+v.img_url+'" alt="" class="img-simple">',
                        '<div class="content col-md-12">',
                        '<div class="titles"></div>',
                        '<div class="buttons-buttom"></div>',
                        '</div>',
                        '</div>',
                        '</div>'].join("");
                });
                $("#swiper-2").append(str);
                y.initSwiper();
                str="";
            });
        });

    }
    function flagDesign(){
       const id=location.search.substr(1);
         y.ajax.getSingleRecord(id,(res)=>{
           const txt=$("#content");
           txt.find(".title").html(res.data[0].title);
           txt.find(".content").html(unescape(res.data[0].content));
           txt.find("img").attr("src",router+res.data[0].img_url);
       });
         y.ajax.getAlbum(id,(res)=>{
             res.data.forEach((v)=>{
                 str+=['<div class="swiper-slide">',
                     '<div class="hawa-banner  text-center buttons-modern">',
                     '<img src="'+router+v.original_path+'" alt="" class="img-simple">',
                     '<div class="content col-md-12">',
                     '<div class="titles"></div>',
                     '<div class="buttons-buttom"></div>',
                     '</div>',
                     '</div>',
                     '</div>'].join("");
             });
             $("#swiper").append(str);
             y.initSwiper();
             str="";
             });
    }
    function flagOdm(lang){
          //odm
         y.ajax.getMultiRecord({categoryId:120}, (res)=> {
            res.data.forEach((v)=>{
                const txt=$("#content");
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").html(router+v.img_url);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                      txt.find(".title").html(v.title);
                      txt.find(".content").html(unescape(v.content));
                      txt.find("img").attr("src",router+v.img_url);
                }
            });
        });
    }
    function flagOdt(lang){
        //odt
        y.ajax.getMultiRecord({categoryId:119}, (res)=> {
            res.data.forEach((v)=>{
                const txt=$("#content");
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").html(router+v.img_url);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }
            });
        });
    }
    function flagIos(lang){
        //ios
        y.ajax.getMultiRecord({categoryId:118}, (res)=> {
            res.data.forEach((v)=>{
                const txt=$("#content");
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").html(router+v.img_url);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }
            });
        });
    }
    function flagPcs(lang){
        //ios
        y.ajax.getMultiRecord({categoryId:117}, (res)=> {
            res.data.forEach((v)=>{
                const txt=$("#content");
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").html(router+v.img_url);
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    txt.find(".title").html(v.title);
                    txt.find(".content").html(unescape(v.content));
                    txt.find("img").attr("src",router+v.img_url);
                }
            });
        });
    }
    function flagAbout(lang){
        function content(res,txt){
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    txt.find("img").attr("src",router+v.img_url).fadeIn();
                    txt.find(".text-light").html(unescape(v.content));
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    txt.find("img").attr("src",router+v.img_url).fadeIn();
                    txt.find(".text-light").html(unescape(v.content));
                }
            });
        }
         //简述
        y.ajax.getMultiRecord({categoryId:104}, (res)=> {
            const txt=$("#content-1"),
                  txt1=$("#content-2");
            res.data.forEach((v,i)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    if(i===0){
                        txt.find(".title").html(v.title);
                        txt.find(".text-light").html(unescape(v.content));
                    }else{
                        txt1.find(".title").html(v.title);
                        txt1.find(".text-light").html(unescape(v.content));
                    }
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                       if(i===1){
                           txt.find(".title").html(v.title);
                           txt.find(".text-light").html(unescape(v.content));
                       }else{
                        txt1.find(".title").html(v.title);
                        txt1.find(".text-light").html(unescape(v.content));
                    }
                }
            });
        });
        //关于我们图集
        y.ajax.getMultiRecord({categoryId:96}, (res)=> {
            res.data.forEach((v)=>{
                str+=['<div class="swiper-slide">',
                    '<div class="hawa-banner  text-center buttons-modern">',
                    '<img src="'+router+v.img_url+'" alt="" class="img-simple">',
                    '<div class="content col-md-12">',
                    '<div class="titles"></div>',
                    '<div class="buttons-buttom"></div>',
                    '</div>',
                    '</div>',
                    '</div>'].join("");
            });
            $("#swiper").append(str);
            y.initSwiper();
            str="";
        });
        //历史 概念 发展 组织
        y.ajax.getMultiRecord({categoryId:105}, (res)=> {
              const txt=$("#content-3");
              content(res,txt);
        });
        y.ajax.getMultiRecord({categoryId:106}, (res)=> {
            const txt=$("#content-4");
            content(res,txt);
        });
        y.ajax.getMultiRecord({categoryId:107}, (res)=> {
            const txt=$("#content-5");
            content(res,txt);
        });
        y.ajax.getMultiRecord({categoryId:108}, (res)=> {
            const txt=$("#content-6");
            content(res,txt);
        });
    }
    function flagDesigner(lang) {
        //设计师合作
        y.ajax.getMultiRecord({categoryId:109}, (res)=> {
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    $("#title").html(v.title);
                    $("#content").html(unescape(v.content));
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    $("#title").html(v.title);
                    $("#content").html(unescape(v.content));
                }
            });
        });
        //在线留言
        $('#form').html5Validate(function () {
            const data={
                txtName:$('.name').val(),
                txtEmail:$('.email').val(),
                tel:$('.tel').val(),
                content:$('textarea').val()
            };
            Yfd.ajax.postMsg(data,function () {
                 const btn=$(".fb-btn").children("input");
                   btn.attr("type","button");
                 let i=4;
                 let timer;
                 timer=setInterval(function () {
                    --i;
                    btn.css({backgroundColor:'#0cc'}).val("SUCCESS!("+i+")");
                    if(i===0){
                        btn.css({backgroundColor:'rgba(244,109,50,0.8)'}).val("SEND MESSAGE");
                        btn.attr("type","submit");
                        i=4;
                        clearInterval(timer);
                    }
                },1000);
            });
        });
    }
    function flagSchool(lang) {
        //设计师合作
        y.ajax.getMultiRecord({categoryId:111}, (res)=> {
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    $("#title").html(v.title);
                    $("#content").html(unescape(v.content));
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    $("#title").html(v.title);
                    $("#content").html(unescape(v.content));
                }
            });
        });
        //在线留言
        $('#form').html5Validate(function () {
            const data={
                txtName:$('.name').val(),
                txtEmail:$('.email').val(),
                tel:$('.tel').val(),
                content:$('textarea').val()
            };
            Yfd.ajax.postMsg(data,function () {
                const btn=$(".fb-btn").children("input");
                btn.attr("type","button");
                let i=4;
                let timer;
                timer=setInterval(function () {
                    --i;
                    btn.css({backgroundColor:'#0cc'}).val("SUCCESS!("+i+")");
                    if(i===0){
                        btn.css({backgroundColor:'rgba(244,109,50,0.8)'}).val("SEND MESSAGE");
                        btn.attr("type","submit");
                        i=4;
                        clearInterval(timer);
                    }
                },1000);
            });
        });
    }
    function flagYarn(lang) {
        //设计师合作
        y.ajax.getMultiRecord({categoryId:110}, (res)=> {
            res.data.forEach((v)=>{
                if(v.title.match(/[\u4e00-\u9fa5]/)&&lang==="cn"){
                    $("#title").html(v.title);
                    $("#content").html(unescape(v.content));
                }else if(v.title.match(/[a-zA-Z]/)&&lang==="en"){
                    $("#title").html(v.title);
                    $("#content").html(unescape(v.content));
                }
            });
        });
        //在线留言
        $('#form').html5Validate(function () {
            const data={
                txtName:$('.name').val(),
                txtEmail:$('.email').val(),
                tel:$('.tel').val(),
                content:$('textarea').val()
            };
            Yfd.ajax.postMsg(data,function () {
                const btn=$(".fb-btn").children("input");
                btn.attr("type","button");
                let i=4;
                let timer;
                timer=setInterval(function () {
                    --i;
                    btn.css({backgroundColor:'#0cc'}).val("SUCCESS!("+i+")");
                    if(i===0){
                        btn.css({backgroundColor:'rgba(244,109,50,0.8)'}).val("SEND MESSAGE");
                        btn.attr("type","submit");
                        i=4;
                        clearInterval(timer);
                    }
                },1000);
            });
        });
    }
    function flagShop(lang){
        const filter= $(".filter");
        const products=$(".products");
        const loading= $(".loading");
        let id=88,
            pageSize=12,
            maxNum="",
            arr=[],
            canGet=true,
            pageIndex=1;
        //高级定制筛选菜单
        y.ajax.getCategory(88,(res)=>{
            if(lang==="cn"){
                str='<option value="default">高级定制</option>';
                res.data.forEach((v)=>{
                    str+='<option value="'+v.id+'">'+v.title+'</option>'
                });
                filter.append(str);
                str="";
            }else if(lang==="en"){
                 str='<option value="default">Customized</option>';
                   res.data.forEach((v)=>{
                         str+='<option value="'+v.id+'">'+v.title_en+'</option>'
                   });
                filter.append(str);
                str="";
            }
        });
        filter.change(function(){
            id=$(this).val();
            products.empty().masonry().masonry('destroy');
            reqGoods(id,pageSize,pageIndex,lang);
        });
        //商品请求
        function reqGoods(id,pageSize,pageIndex,lang){
              let  html="";
            y.ajax.getMultiRecordVideo({categoryId:id,pageSize:pageSize,pageIndex:pageIndex},(res)=>{
                     maxNum = Math.ceil(res.total / pageSize);
                      res.data.forEach((v)=>{
                          arr.push(router + v.img_url);
                      });
                y.imgLoaded(arr,()=>{
                     res.data.forEach((v)=>{
                         if(lang==="cn"){
                             str+=['<div class="col-md-4 col-sm-6 col-xs-6 hawa-product product pi ">',
                                 '<div class="content-product">',
                                 '<img src="'+router + v.img_url+'" alt="product-photo">',
                                 '<div class="hover-product"></div>',
                                 '</div>',
                                 '<div class="hawa-product-info">',
                                 '<div class="hawa-product-info-content">',
                                 '<h3 class="hawa-product-title">',
                                 '<a href="javascript:">'+v.title+'</a>',
                                 '</h3>',
                                 '<span class="price"><span class="amount">'+v.sell_price+'</span></span>',
                                 '</div>',
                                 '</div>',
                                 '</div>'].join("");
                         }else{
                             str+=['<div class="col-md-4 col-sm-6 col-xs-6 hawa-product product pi ">',
                                 '<div class="content-product">',
                                 '<img src="'+router + v.img_url+'" alt="product-photo">',
                                 '<div class="hover-product"></div>',
                                 '</div>',
                                 '<div class="hawa-product-info">',
                                 '<div class="hawa-product-info-content">',
                                 '<h3 class="hawa-product-title">',
                                 '<a href="javascript:">'+v.title_en+'</a>',
                                 '</h3>',
                                 '<span class="price"><span class="amount">'+v.sell_price+'</span></span>',
                                 '</div>',
                                 '</div>',
                                 '</div>'].join("");
                         }

                     });
                     html=$(str);
                     if(pageIndex===1){
                         products.append(html).masonry({
                             itemSelector: '.pi',
                             gutter: 0,
                             isAnimated: true,
                             percentPosition: true
                         });
                     }else{
                         products.append(html).masonry("appended", html).masonry();
                         canGet=true;
                     }
                    str="";
                })
            })
        }
        reqGoods(id,pageSize,pageIndex,lang);
        //滚动底部请求
        $(window).scroll(function(){
            let scrollTop =$(this).scrollTop(),
                loadingTop=loading.offset().top,
                loadingH=loading.outerHeight(),
                winH=$(this).height();
          if(scrollTop>=loadingTop-winH+loadingH){
              if(canGet&&pageIndex<maxNum){
                  ++pageIndex;
                  canGet=false;
                  reqGoods(id,pageSize,pageIndex,lang);
              }else{
                  loading.fadeOut();
              }
          }
        })

    }
    function flagNews(lang){
        let  id="",
            pageSize=6,
            maxNum="",
            canGet=true,
            loading=$(".loading"),
            pageIndex=1;
        if(lang==='en'){
          id=121;
        }else{
          id=122;
        }
        //新闻列表请求
        getNes(id,pageSize,pageIndex);
        function getNes(id,pageSize,pageIndex){
            y.ajax.getMultiRecord({categoryId:id,pageSize:pageSize,pageIndex:pageIndex},(res)=>{
                maxNum = Math.ceil(res.total / pageSize);
                res.data.forEach((v)=>{
                    str+=['<div class="hawa-post">',
                        '<div class="post-header">',
                        '<a href="newsxq.html?'+v.id+'">',
                        '<p><img class="alignnone" src="'+router+v.img_url+'" alt="single"></p>',
                        '</a>',
                        '</div>',
                        '<div class="post-info">',
                        '<ul>',
                        '<li>'+v.addtime+'</li>',
                        '</ul>',
                        '</div>',
                        '<a href="newsxq.html?'+v.id+'">',
                        '<h3 class="title">'+v.title+'</h3>',
                        '</a>',
                        '<div class="post-excerpt">',
                        '<p>'+unescape(v.zhaiyao)+'</p>',
                        '</div>',
                        '</div>'].join("");
                });
                $("#news").append(str);
                str="";
                canGet=true;
            })
        }
        //滚动底部请求
        $(window).scroll(function(){
            let scrollTop =$(this).scrollTop(),
                loadingTop=loading.offset().top,
                loadingH=loading.outerHeight(),
                winH=$(this).height();
            if(scrollTop>=loadingTop-winH+loadingH){
                if(canGet&&pageIndex<maxNum){
                    ++pageIndex;
                    canGet=false;
                    getNes(id,pageSize,pageIndex);
                }else{
                    loading.fadeOut();
                }
            }
        })
    }
    function flagNewsXq(){
         const id=location.search.substr(1);
        //新闻详情请求
        y.ajax.getSingleRecord(id,(res)=>{
             $("#content").html(unescape(res.data[0].content));
             if(res.data[0].nextid!=="0"){
                 $("#next").attr("href","newsxq.html?"+res.data[0].nextid).find("i").html(res.data[0].nexttitle);
             };
            if(res.data[0].preid!=="0"){
                $("#prev").attr("href","newsxq.html?"+res.data[0].preid).find("i").html(res.data[0].prtitle);
            }
        })
    }
})(jQuery,window,document,Yfd);